import { Circle, Image, View, XStack } from "@/components";
import AutolinkText from "@/components/AutolinkText";
import type { CuraiMessageProps } from ".";

type OutputTextProps = CuraiMessageProps & {
  content: string;
};

export default function OutputText({
  content,
  senderPhotoUrl,
}: OutputTextProps) {
  return (
    <XStack
      gap="$50"
      alignItems="flex-end"
      maxWidth="90%"
      alignSelf="flex-start"
      marginVertical="$100"
    >
      {senderPhotoUrl ? (
        <Image
          source={{ uri: senderPhotoUrl }}
          width="$300"
          height="$300"
          borderRadius={100_000}
        />
      ) : (
        <Circle size="$300" backgroundColor="$textSecondary" />
      )}
      <View
        flex={1}
        backgroundColor="$fillClinician"
        padding="$200"
        borderRadius="$150"
      >
        <AutolinkText
          text={content}
          dataTrackingId="curai-message-external-link"
        />
      </View>
    </XStack>
  );
}
